import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import { getContact } from "../../store/actions/contacts_action";
import Spinner from "../../components/layout/Spinner";
import { inputFields } from "../../shared/enums/contacts_enum";
import SingleView from "../../components/common/SingleView";
const ViewContact = ({ getContact, match, contact: { loading, contact } }) => {
  useEffect(() => {
    getContact(match.params.id);
  }, [match]);

  const [fields, setFields] = useState(Object.keys(inputFields));
  console.log(fields);
  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title="Contacts"
          mainLinkTitle="Contacts"
          mainLinkUrl="/contacts"
          activeLink="View"
        />
        {!loading ? (
          contact && (
            <SingleView
              data={contact}
              inputFields={inputFields}
              label="Contact"
              link="contacts"
              id={contact.id}
            />
          )
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ contact: state.contact });

const mapDispatchToProps = { getContact };

export default connect(mapStateToProps, mapDispatchToProps)(ViewContact);
